"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbNonEditableControl = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _shapes = require("../../skybase-core/shapes");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Helps to render view-only representation of editable SkyBase components.
var SbNonEditableControl = function SbNonEditableControl(props) {
  var className = props.className,
      value = props.value,
      id = props.id,
      inputRef = props.inputRef,
      style = props.style;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(_constants.DEFAULT_CLASS_NAME, className),
    id: id,
    style: style,
    ref: inputRef
  }, value);
};

exports.SbNonEditableControl = SbNonEditableControl;
SbNonEditableControl.propTypes = {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  value: _propTypes.default.node.isRequired,
  style: _propTypes.default.object,
  // eslint-disable-line
  inputRef: _shapes.PropTypeRef
};
SbNonEditableControl.defaultProps = {
  className: null,
  id: null,
  style: null,
  inputRef: function inputRef() {}
};
//# sourceMappingURL=sb-non-editable-control.js.map